/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, Container, Row } from "react-bootstrap";
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { Button, Input, ImageUpload } from "../../components";
import { DropDown } from "../../components/DropDown";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { messages } from "../../utilities/Messages";
import { UserDataObjType } from "../../utilities/types";
import { VALID_IMAGE_TYPES, DEFAULT_MAX_IMAGE_SIZE } from "../../utilities/imageUtils";
const today = new Date();

today.setDate(today.getDate() - 1);
const formattedYesterday = today.toISOString().split("T")[0];
const AddUpdateUserForm = (props: any) => {
  const { userData, setUserData, buttonName, HandleSubmit, submitButton } = props;
  const navigate = useNavigate();
  const { AllFacilitiesData, errorMessage } = useAppSelector(state => state.facilityList);
  const { roles } = useAppSelector(state => state.userRoles);
  const { states } = useAppSelector(state => state.states);

  const [selectFacility, setSelectFacility] = useState(userData?.userFacilities);
  const [imageError, setImageError] = useState("");
  const getMessage = messages.users;

  const [schema, setSchema] = useState({
    firstName: yup
      .string()
      .required(getMessage.firstName_isNotEmpty)
      .matches(/^[a-zA-Z .-]+$/, getMessage.firstName_matches)
      .min(3, getMessage.firstName_minLength)
      .max(30, getMessage.firstName_maxLength),
    lastName: yup
      .string()
      .required(getMessage.lastName_isNotEmpty)
      .matches(/^[a-zA-Z .-]+$/, getMessage.lastName_matches)
      .min(1, getMessage.lastName_minLength)
      .max(30, getMessage.lastName_maxLength),
    // gender: yup.string().required(getMessage.gender_isNotEmpty),
    gender: yup.string().notRequired(),
    phone: yup
      .string()
      .required(getMessage.phone_isNotEmpty)
      .matches(/^[0-9]\d{9}$/, getMessage.phone_matches),
    email: yup
      .string()
      .nullable()
      .required(getMessage.email_isNotEmpty)
      .matches(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, getMessage.email_invalid_email)
      .max(70, getMessage.email_maxLength),
    aadharNumber: yup
      .string()
      .required(getMessage.aadharNumber_isNotEmpty)
      .matches(/^[0-9]\d{11}$/, getMessage.aadharNumber_maxLength),

    addressLine1: yup
      .string()
      // .required(getMessage.addressLine1_isNotEmpty)
      .notRequired()
      .max(50, getMessage.addressLine1_maxLength),
    addressLine2: yup.string().nullable().notRequired().max(50, getMessage.addressLine2_maxLength),
    landmark: yup.string().nullable().notRequired().max(50, getMessage.landmark_maxLength),
    pincode: yup
      .string()
      // .required(getMessage.pincode_isNotEmpty)
      .notRequired()
      .matches(/^[1-9][0-9]{5}$/, {
        message: getMessage.pincode_matches,
        excludeEmptyString: true,
      }),
    city: yup
      .string()
      // .required(getMessage.city_isNotEmpty)
      .notRequired()
      .max(50, getMessage.city_maxLength),

    state: yup
      .string()
      // .required(getMessage.state_isNotEmpty)
      .notRequired()
      .max(50, getMessage.state_maxLength),

    birthDate: yup.string().required("Date of Birth is required"),
    image: yup
      .mixed()
      .test(getMessage.image_isValid, getMessage.image_isNotValid, (value: any) => {
        if (!value || (typeof value === "object" && !value?.length)) return true;
        if (typeof value === "string") return true;
        const file = value instanceof File ? value : value?.[0];
        if (!file) return true;
        return VALID_IMAGE_TYPES.includes(file.type);
      })
      .test(getMessage.file_size, getMessage.file_fixSize, (value: any) => {
        if (!value || (typeof value === "object" && !value?.length)) return true;
        if (typeof value === "string") return true;
        const file = value instanceof File ? value : value?.[0];
        if (!file) return true;
        return file.size <= DEFAULT_MAX_IMAGE_SIZE;
      }),
  });

  if (errorMessage) {
    toast.error(errorMessage.message);
  }

  useEffect(() => {
    if (buttonName === "Add User") {
      setSchema(
        Object.assign(schema, {
          password: yup
            .string()
            .required(getMessage.password_isNotEmpty)
            .matches(/^\S+$/, getMessage.password_matches)
            .min(8, getMessage.password_minLength)
            .max(15, getMessage.password_maxLength),
          cpassword: yup
            .string()
            .matches(/^\S+$/, getMessage.cpassword_matches)
            .oneOf([yup.ref("password")], getMessage.cpassword_oneof),
          roleId: yup.string().required(getMessage.role_isNotEmpty),
        })
      );
    }
  }, [buttonName]);

  useEffect(() => {
    if (userData?.roleId === "5" && schema?.aadharNumber) {
      setSchema((_oldSchema: any) => {
        _oldSchema["aadharNumber"] = yup
          .string()
          .test("len", getMessage.aadharNumber_exactly, val => !val || val.length === 12);
        return { ..._oldSchema };
      });
    }
    if (userData?.roleId !== "5" && !schema?.aadharNumber) {
      setSchema((_oldSchema: any) => {
        _oldSchema["aadharNumber"] = yup
          .string()
          .required(getMessage.aadharNumber_isNotEmpty)
          .matches(/^[0-9]\d{11}$/, getMessage.aadharNumber_maxLength);
        return { ..._oldSchema };
      });
    }
  }, [userData?.roleId]);

  const UserDataSchema = yup.object().shape(schema);
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm<UserDataObjType>({
    resolver: yupResolver(UserDataSchema),
  });

  const handleCancel = () => {
    navigate("/users");
  };

  const onSubmit: SubmitHandler<any> = data => {
    let formData = new FormData();
    delete data.cpassword;
    data.image = userData?.userImage ? userData?.userImage : data.image[0] ? data.image[0] : "";
    let payload = {
      ...data,
      birthDate: userData.birthDate ? userData.birthDate.split("/").reverse().join("-") : "",
      isActive: userData.isActive,
      userFacilities: JSON.stringify(selectFacility),
      roleId: userData.roleId,
      country: "India",
    };
    for (let key in payload) {
      formData.append(key, payload[key]);
    }
    HandleSubmit(formData);
  };

  const options = AllFacilitiesData?.map((item, id) => {
    return {
      labelKey: item.id,
      value: `${item.name}`,
    };
  });

  const handleChange = (value: any) => {
    setSelectFacility(value.selectedKey);
  };

  return (
    <Container fluid className="g-0">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <Card>
          <Card.Body>
            <Card.Title className="text-start">{buttonName}</Card.Title>
            <h4 className="card-title2 text-start">Personal Information</h4>
            <hr />
            <ImageUpload
              value={userData?.userImage}
              onChange={(img) => setUserData({ ...userData, userImage: img || null })}
              onError={setImageError}
              error={imageError || (errors.image?.message as string) || ""}
              label="Upload Profile Photo"
              sizeLabel="Maximum file size 5MB"
              register={register}
              labelAs="h6"
            />
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="firstname" className="form-label">
                    First Name <small className="text-danger">*</small>
                  </label>
                  <Input
                    defaultValue={userData?.firstName}
                    type="text"
                    placeholder="Enter First Name"
                    id="adduserfirstname"
                    name="firstName"
                    className="form-control"
                    register={register}
                    required
                  />
                  <span className="error-msg">{errors.firstName?.message}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="lastname" className="form-label">
                    Last Name <small className="text-danger">*</small>
                  </label>
                  <Input
                    defaultValue={userData?.lastName}
                    type="text"
                    placeholder="Enter Last Name"
                    id="adduserlastname"
                    name="lastName"
                    className="form-control"
                    register={register}
                    required
                  />
                  <span className="error-msg">{errors.lastName?.message}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="gender" className="form-label">
                    Gender
                    {/* <small className="text-danger">*</small> */}
                  </label>
                  <DropDown
                    defaultValue={userData?.gender}
                    name="gender"
                    id="addusergender"
                    className="form-control"
                    register={register}
                    // required
                  >
                    <option hidden disabled value="">
                      Select Gender
                    </option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </DropDown>
                  <span className="error-msg">{errors.gender?.message}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <Row className="g-0">
                    <label htmlFor="phone" className="form-label">
                      Mobile Number <small className="text-danger">*</small>
                    </label>
                    <Input
                      defaultValue={userData?.phone}
                      type="number"
                      placeholder="Mobile Number"
                      id="addusernumber"
                      name="phone"
                      className="form-control"
                      register={register}
                      required
                      onKeyDown={(e: any) =>
                        ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                      }
                      onWheel={(e: any) => e.target.blur()}
                    />
                  </Row>
                  <span className="error-msg">{errors.phone?.message}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="role" className="form-label">
                    Role <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    defaultValue={userData?.roleId}
                    id="adduserrole"
                    name="roleId"
                    className="form-control"
                    register={register}
                    required
                    onChange={(e: any) => {
                      setUserData({
                        ...userData,
                        roleId: e.target.value,
                      });
                      setSelectFacility([]);
                    }}
                    disabled={buttonName === "Edit User"}
                  >
                    <option hidden disabled value="">
                      Select Role
                    </option>
                    {roles?.map(item => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.displayName}
                        </option>
                      );
                    })}
                  </DropDown>
                  <span className="error-msg">{errors.roleId?.message}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="role" className="form-label">
                    Select Facility{" "}
                  </label>
                  <BootstrapSelect
                    className="form-select-custom form-control"
                    selectStyle=""
                    actionBtnStyle="btn-outline-primary"
                    options={options}
                    isMultiSelect={userData.roleId !== "3"}
                    showTick={true}
                    defaultOptions={selectFacility}
                    showSearch={true}
                    showAction={true}
                    placeholder="Select Facility For User"
                    onChange={handleChange}
                    disabled={["1", "5", "6"].includes(userData.roleId)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col col={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="adhar" className="form-label">
                    Aadhar Number{" "}
                    {userData?.roleId !== "5" && <small className="text-danger">*</small>}
                  </label>
                  <Input
                    defaultValue={userData?.aadharNumber}
                    type="number"
                    placeholder="Enter Aadhar Number"
                    id="adduseradhar"
                    name="aadharNumber"
                    className="form-control"
                    register={register}
                    required={userData?.roleId !== "5"}
                    onKeyDown={(e: any) =>
                      ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{errors.aadharNumber?.message}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="date" className="form-label">
                    Date of Birth <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="date"
                    defaultValue={userData?.birthDate?.split("/").reverse().join("-")}
                    formate="dd-mm-yyyy"
                    className="form-control"
                    style={{ cursor: "pointer" }}
                    id="birthDate"
                    name="birthDate"
                    register={register}
                    onChange={(e: any) => setUserData({ ...userData, birthDate: e.target.value })}
                    max={formattedYesterday}
                  />
                  <span className="error-msg">{errors.birthDate?.message}</span>
                </div>
              </Col>
            </Row>
            <Row>
              {buttonName === "Add User" && (
                <>
                  <Col lg={6}>
                    <div className="mb-3 text-start">
                      <label htmlFor="password" className="form-label">
                        Password <small className="text-danger">*</small>
                      </label>
                      <Input
                        type="password"
                        placeholder="Enter Password"
                        id="adduserpassword"
                        name="password"
                        className="form-control"
                        register={register}
                        required
                      />
                      <span className="error-msg">{errors.password?.message}</span>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3 text-start">
                      <label htmlFor="cpassword" className="form-label">
                        Confirm Password <small className="text-danger">*</small>
                      </label>
                      <Input
                        type="password"
                        placeholder="Enter Confirm Password"
                        id="addusercpassword"
                        name="cpassword"
                        className="form-control"
                        register={register}
                      />
                      <span className="error-msg">{errors.cpassword?.message}</span>
                    </div>
                  </Col>
                </>
              )}
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="status" className="form-label">
                    Status <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    defaultValue={userData?.isActive}
                    onChange={(e: any) => setUserData({ ...userData, isActive: e.target.value })}
                    name="userstatus"
                    id="userstatus"
                    className="form-control"
                  >
                    <option hidden disabled value="">
                      Select User Status
                    </option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </DropDown>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="email" className="form-label">
                    Email Address <small className="text-danger">*</small>
                  </label>
                  <Input
                    defaultValue={userData?.email}
                    type="text"
                    placeholder="Enter Email Address"
                    id="adduseremail"
                    name="email"
                    className="form-control"
                    register={register}
                  />
                  <span className="error-msg">{errors.email?.message}</span>
                </div>
              </Col>
            </Row>
            <h4 className="card-title2 text-start mt-3 mb-0">Address Information</h4>
            <hr className="mb-4" />
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="address1" className="form-label">
                    Address line 1{/* <small className="text-danger">*</small> */}
                  </label>
                  <Input
                    defaultValue={userData?.addressLine1}
                    type="text"
                    placeholder="Enter Address"
                    id="adduseraddress1"
                    name="addressLine1"
                    className="form-control"
                    register={register}
                    // required
                  />
                  <span className="error-msg">{errors.addressLine1?.message}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="address2" className="form-label">
                    Address line 2
                  </label>
                  <Input
                    defaultValue={userData?.addressLine2}
                    type="text"
                    placeholder="Enter Address"
                    id="adduseraddress2"
                    name="addressLine2"
                    className="form-control"
                    register={register}
                  />
                  <span className="error-msg">{errors.addressLine2?.message}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="landmark" className="form-label">
                    Landmark
                  </label>
                  <Input
                    defaultValue={userData?.landmark}
                    type="text"
                    placeholder="Enter Landmark"
                    id="landmark"
                    name="landmark"
                    className="form-control"
                    register={register}
                  />
                  <span className="error-msg">{errors.landmark?.message}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="pincode" className="form-label">
                    Pincode
                    {/* <small className="text-danger">*</small> */}
                  </label>
                  <Input
                    defaultValue={userData?.pincode}
                    type="number"
                    placeholder="Enter Pincode"
                    id="adduserpincode"
                    name="pincode"
                    className="form-control"
                    register={register}
                    // required
                    onKeyDown={(e: any) =>
                      ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{errors.pincode?.message}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="city" className="form-label">
                    City
                    {/* <small className="text-danger">*</small> */}
                  </label>
                  <Input
                    defaultValue={userData?.city}
                    type="text"
                    placeholder="Enter City"
                    id="addusercity"
                    name="city"
                    className="form-control"
                    register={register}
                    // required
                  />
                  <span className="error-msg">{errors.city?.message}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="state" className="form-label">
                    State
                    {/* <small className="text-danger">*</small> */}
                  </label>
                  <DropDown
                    defaultValue={userData?.state}
                    name="state"
                    id="adduserstate"
                    className="form-control"
                    register={register}
                    // required
                  >
                    <option hidden disabled value="">
                      Select State
                    </option>
                    {states?.map((item: any) => {
                      return (
                        <option key={item.code} value={item.name}>
                          {item.name}
                        </option>
                      );
                    })}
                  </DropDown>
                  <span className="error-msg">{errors.state?.message}</span>
                </div>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col className="text-end">
                <ButtonGroup>
                  <Button
                    onClick={() => handleCancel()}
                    type="button"
                    bname="Cancel"
                    name="cancel"
                    id="cancel"
                    className="btn btn-light rounded-1 me-3"
                  ></Button>
                  <Button
                    type="submit"
                    bname={
                      buttonName === "Add User"
                        ? submitButton
                          ? "Submitting"
                          : "Submit"
                        : submitButton
                          ? "Updating"
                          : "Update"
                    }
                    name={buttonName === "Add User" ? "adduser" : "update"}
                    id={buttonName === "Add User" ? "adduser" : "update"}
                    className="btn btn-primary rounded-1"
                    disabled={submitButton}
                  ></Button>
                </ButtonGroup>
              </Col>
            </Row>

          </Card.Body>
        </Card>
      </form>
    </Container>
  );
};

export { AddUpdateUserForm };
